import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes/Routes";
import ScrollToTop from "components/ScrollToTop";
import { ViewportProvider } from "./contexts/viewportProvider";

const app = () => (
  <ViewportProvider>
    <BrowserRouter>
      <ScrollToTop />
      <Routes />
    </BrowserRouter>
  </ViewportProvider>
);

export default app;
